import React from 'react';

const EventContext = React.createContext({
  eventObj: null,
});

export default EventContext;
